const cssGradientBG = `

  .fpt-modal-gradient {
    background: rgb(253, 245, 236);
    background: linear-gradient(180deg, rgba(224, 236, 248, 1) 0%, rgba(253, 245, 236, 1) 100%);
  }
`; 

export default cssGradientBG;
